import styled from 'styled-components/macro';
import { row_center_both, column, column_center_horizontal, row_center_end, column_center_vertical } from 'src/App/Styles/styles-helpers';
import { GlobalColors, Rules } from 'src/App/Styles/Globals';
import Images from 'src/App/Images';
import { LsButton } from 'src/App/Styles/ls-components';

export const OverlayContain = styled.div`
	background: ${GlobalColors.transparentBlack};
	width: 100vw;
	height: 100vh;
	position: absolute;
	top: 0;
	right: 0;
	left: 0;
	bottom: 0;
	z-index: 10;
	${row_center_both}
`;
export const OverlayWrapper = styled.div`
	width: 80%;
	max-width: 400px;
	${column}
	gap: 1em;
`;
export const OverlayTop = styled.div`
	background: ${GlobalColors.gradient3};
	border-radius: ${Rules.radiusRoundContainer};
	padding: 1em;
	padding-bottom: 2em;
`;
export const OverlayBtn = styled.div<{ processing: boolean; promptDisabled: boolean; notLoggedIn: boolean }>`
	text-align: center;
	user-select: none;
	cursor: ${({ processing, promptDisabled }) => (processing ? 'progress' : promptDisabled ? 'no-drop' : 'pointer')};
	background: ${GlobalColors.newGradient};
	opacity: ${({ processing, promptDisabled }) => (processing || promptDisabled ? '.4' : '1')};
	${row_center_both}
	gap: 0.5em;
	padding: 0.5em;
	border-radius: ${Rules.radiusButtonCTA};
	font-size: 18px;
	font-weight: 800;
	min-height: 40px;
	position: relative;
`;

export const OverlayTopTitle = styled.div`
	display: flex;
	justify-content: flex-end;
	svg {
		cursor: pointer;
	}
	&:before {
		content: '';
		display: block;
		width: 20px;
	}
	z-index: 20;
	position: relative;
`;
export const OverlaTopCommandName = styled.div`
	${column_center_horizontal}
	margin: .4em;
	text-align: center;
	overflow: hidden;
	word-break: break-word;
	h1 {
		margin: 0;
	}
	span {
		color: #878787;
		font-size: 12px;
	}
`;
export const OverlayTopCommandType = styled.div`
	${row_center_both}
	margin-bottom: 0.4em;
	text-align: center;
	font-size: 16px;
	gap: 2em;
	color: #878787;
`;
export const OverlayTopPriceContain = styled.div`
	text-align: center;
	font-size: 16px;
	${row_center_both}
	gap: 0.5em;
	margin: 20px 0 0;
	img {
		width: 20px;
	}
`;
export const OverlayTopCommandTypeItem = styled.div`
	${column}
	gap: 0.5em;
	span {
		color: #878787;
		font-size: 12px;
	}
	div {
		display: flex;
		align-items: center;
		gap: 0.5em;
		img {
			width: 20px;
		}
	}
`;

export const OverlayBitIcon = styled.img``;

export const OverlayInputContain = styled.div`
	${column}
	gap: .5rem;
	text-align: center;
	font-size: 12px;
	color: #878787;
	background: ${GlobalColors.black25};
	border-radius: 10px;
	padding: 0.5rem;
`;

export const OverlayInputLabel = styled.div`
	text-align: left;
`;
export const OverlayInputContainer = styled.div`
	border-radius: 5px;
`;

export const OverlayInput = styled.textarea`
	background: transparent;
	color: white;
	overflow: auto;
	height: auto;
	width: 100%;
	resize: none;
	font: inherit;
	border: 0;
	margin: 0;
	display: block;
	letter-spacing: inherit;
	padding: 0.5rem;
	outline: none;
	-webkit-tap-highlight-color: transparent;
`;
export const CoolDownCommandContainer = styled.div`
	${row_center_both}
	gap: 0.5em;
	padding: 0.5rem 1rem;
	border-radius: ${Rules.radiusButtonCTA};
	font-size: 1rem;
	font-weight: 800;
	min-height: 40px;
	position: relative;
	background: #667db6; /* fallback for old browsers */
	background: -webkit-linear-gradient(to right, #667db6, #0082c8, #0082c8, #667db6); /* Chrome 10-25, Safari 5.1-6 */
	background: linear-gradient(to right, #667db6, #0082c8, #0082c8, #667db6); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
	position: relative;
`;

export const ImgFreezitem = styled(Images.FreezBtnItem)`
	width: 40px;
	height: 40px;
	transform: rotateZ(90deg);
	animation: turn 1s infinite;
	@keyframes turn {
		from {
			transform: rotateZ(0deg);
		}
		to {
			transform: rotateZ(180deg);
		}
	}
`;

export const OverlayImageContainer = styled.div`
	position: relative;
	background-color: ${GlobalColors.separator};
	overflow: hidden;
	border-radius: ${Rules.radiusRoundContainer};
	min-height: 150px;
	${row_center_both}
	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		position: absolute;
		inset: 0;
		z-index: 1;
	}
	&:before {
		content: '';
		position: absolute;
		inset: 0;
		z-index: 2;
		background-color: black;
		opacity: 0.3;
	}
`;

export const OverlayImgPreviewbtn = styled(LsButton)`
	background: ${GlobalColors.separator};
`;
export const OverlayVideoWrapper = styled.div`
	${column}
	gap:.5rem;
	width: 90vw;
	max-width: 500px;
	video {
		width: 100%;
	}
`;
